import * as React from 'react';
import { calculateLineHeightClosestChild } from './utils';
export function useIsMultiLine(ref, needCalculate) {
  const [isMultiLine, setIsMultiLine] = React.useState(false);
  React.useEffect(() => {
    if (ref.current && needCalculate) {
      const element = ref.current;
      const lineHeight = calculateLineHeightClosestChild(element);
      setIsMultiLine(parseInt(window.getComputedStyle(element).height, 10) > lineHeight);
    }
  }, [ref, needCalculate]);
  return isMultiLine;
}